import React, {useContext, useEffect, useState} from "react";
import {FormDataContext} from "../../contexts/FormDataContext";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup, IconButton, Tooltip,
  Typography,
} from '@mui/material';
import {nestTaxonomyChildren} from "../../utilities/NestTaxonomyChildren";
import { SectionHeading } from '../SectionHeading';
import { SectionPaper } from '../SectionPaper';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


export const Attributes = () => {
  const [attributesWhoAreYou, setAttributesWhoAreYou]  = useState([]);
  const [attributesYourInterests, setAttributesYourInterests] = useState([]);
  const {
    attributesAll,
    yourInterests,
    selectedAttributes,
    setSelectedAttributes,
    preferencesFormDisabled,
    setIsFormDataChanged,
  } = useContext(FormDataContext);

  useEffect(() => {
    if (attributesAll.length > 0) {
      let filteredAttributesWhoAreYou = attributesAll.filter(
        (attr) => !yourInterests.includes(attr.attribute_id)
      );
      let filteredAttributesYourInterests = attributesAll.filter(
        (attr) => yourInterests.includes(attr.attribute_id)
      );
      filteredAttributesWhoAreYou = nestTaxonomyChildren(
        filteredAttributesWhoAreYou,
        'attribute_id',
        'parent_attribute_id'
      );
      filteredAttributesYourInterests = nestTaxonomyChildren(
        filteredAttributesYourInterests,
        'attribute_id',
        'parent_attribute_id'
      );
      setAttributesWhoAreYou(filteredAttributesWhoAreYou);
      setAttributesYourInterests(filteredAttributesYourInterests);
    }
  }, [attributesAll]);

  const AttributesChildrenComponent = ({attrChildren, attrName}) => {
    return (
      <>
        <Typography>{attrName}</Typography>
        <Box sx={{marginLeft: '8px'}}>
          {attrChildren.map(attr => (
            <div key={`childInner${attr.attribute_id}`}>
              <FormControlLabel key={`label${attr.attribute_id}`} control={
                <AttributeCheckbox value={attr.attribute_id}/>
              } label={attr.name} />
              {attr.children &&
                <AttributesChildrenComponent attrChildren={attr.children} attrName={attr.name}/>
              }
            </div>
          ))}
        </Box>
      </>
    );
  };

  const AttributeCheckbox = ({value}) => {
    const handleAttributeChange = event => {
      const isChecked = event.target.checked;
      if (isChecked) {
        setSelectedAttributes(prevAttr => [...prevAttr, value])
      } else {
        setSelectedAttributes(prevAttr => prevAttr.filter(attrId => attrId !== value));
      }
      setIsFormDataChanged(true);
    };
    return (
      <Checkbox
        onChange={handleAttributeChange}
        value={value}
        checked={selectedAttributes.includes(value)}
        disabled={preferencesFormDisabled}
      />
    );
  };

  const DefinitionTooltip = ({definition}) => {
    return (
      <Tooltip title={<Typography dangerouslySetInnerHTML={{ __html: definition }}/>} enterTouchDelay={1}>
        <IconButton>
          <InfoOutlinedIcon sx={{fontSize: '1.25rem'}}/>
        </IconButton>
      </Tooltip>
    )
  }


  return (
    <>
      <SectionHeading>
        Who Are You?
      </SectionHeading>
      <SectionPaper>
        <FormGroup>
          {attributesWhoAreYou.map(attr => (
            <div key={attr.attribute_id}>
              {!attr.children
                ? <FormControlLabel
                    key={`label${attr.attribute_id}`}
                    control={
                      <AttributeCheckbox value={attr.attribute_id}/>
                    }
                    label={
                      <Box display="flex" alignItems="center">
                        {attr.name}
                        {attr.definition &&
                          <DefinitionTooltip definition={attr.definition}/>
                        }
                      </Box>
                    }
                  />
                : <AttributesChildrenComponent key={`child${attr.attribute_id}`} attrChildren={attr.children} attrName={attr.name}/>
              }
            </div>
          ))}
        </FormGroup>
      </SectionPaper>
      {/*<Typography component="h2">
        YOUR INTERESTS
      </Typography>
      <FormGroup>
        {attributesYourInterests.map(attr => (
          <div key={attr.attribute_id}>
            {!attr.children
              ? <FormControlLabel key={`label${attr.attribute_id}`} control={<Checkbox/>} label={attr.name} />
              : <AttributesChildrenComponent key={`child${attr.attribute_id}`} attrChildren={attr.children} attrId={attr.attribute_id} attrName={attr.name}/>
            }
          </div>
        ))}
      </FormGroup>*/}
    </>
  );
}
